// import { useEffect, useRef, useState } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
// import { fetchExperiences, IMG } from './data';
// import { Label } from './utils';

// gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

// // ── Swap this URL with your own image ──────────────────────
// const CUSTOM_IMAGE_URL = './bg_rc.png';
// // Image display size (in SVG units / px)
// const IMG_SIZE = 48;

// export default function Experience({ loaded, isMobile }) {
//   const [experiences, setExperiences] = useState([]);
//   const expRef       = useRef(null);
//   const pathSvgRef   = useRef(null);
//   const rocketSvgRef = useRef(null);
//   const wrapRef      = useRef(null);

//   // ── Fetch from Firestore ──────────────────────────────────
//   useEffect(() => {
//     fetchExperiences().then(setExperiences).catch(console.error);
//   }, []);

//   // ── Custom-image path animation ───────────────────────────
//   useEffect(() => {
//     if (!loaded || experiences.length === 0) return;

//     const root      = expRef.current;
//     const pathSvg   = pathSvgRef.current;
//     const rocketSvg = rocketSvgRef.current;
//     const wrap      = wrapRef.current;
//     if (!root || !pathSvg || !rocketSvg || !wrap) return;

//     let cleanup = null;

//     const build = () => {
//       if (root._rocketTriggers) {
//         root._rocketTriggers.forEach(t => { try { t?.kill?.(); } catch (_) {} });
//         delete root._rocketTriggers;
//       }

//       const stops = root.querySelectorAll('.exp-stop');
//       if (!stops.length) return;

//       gsap.set(stops, { clearProps: 'transform,opacity' });
//       void wrap.getBoundingClientRect();

//       const W      = wrap.offsetWidth;
//       const totalH = wrap.offsetHeight;
//       const cx     = W / 2;
//       const amp    = isMobile ? Math.min(cx * 0.28, 60) : Math.min(cx * 0.32, 130);

//       const wrapRect = wrap.getBoundingClientRect();
//       const dots = [];
//       let runY = 60;

//       stops.forEach((s, i) => {
//         const card = s.querySelector(`#exp-card-${i}`) || s.firstElementChild;
//         let cardX;
//         if (card) {
//           const cr = card.getBoundingClientRect();
//           cardX = (cr.left + cr.width / 2) - wrapRect.left;
//         } else {
//           cardX = i % 2 === 0 ? cx - amp : cx + amp;
//         }
//         dots.push({ x: cardX, y: runY + s.offsetHeight / 2, color: experiences[i]?.color || 'var(--acid)' });
//         runY += s.offsetHeight;
//       });

//       const startY = 10;
//       const endY   = totalH - 10;
//       let d = `M ${cx} ${startY}`;
//       dots.forEach(({ x, y }, i) => {
//         const prevX = i === 0 ? cx : dots[i - 1].x;
//         const prevY = i === 0 ? startY : dots[i - 1].y;
//         d += ` C ${prevX} ${prevY + (y - prevY) * 0.5}, ${x} ${y - (y - prevY) * 0.25}, ${x} ${y}`;
//       });
//       const last = dots[dots.length - 1];
//       d += ` C ${last.x} ${last.y + 50}, ${cx} ${endY - 20}, ${cx} ${endY}`;

//       const sizeSvg = (svg) => {
//         svg.setAttribute('viewBox', `0 0 ${W} ${totalH}`);
//         svg.setAttribute('width',   W);
//         svg.setAttribute('height',  totalH);
//         svg.style.width  = `${W}px`;
//         svg.style.height = `${totalH}px`;
//       };

//       const NS = 'http://www.w3.org/2000/svg';

//       // ── Path SVG (trail + dots) ───────────────────────────
//       sizeSvg(pathSvg);
//       pathSvg.innerHTML = '';

//       const trail = document.createElementNS(NS, 'path');
//       trail.setAttribute('d', d); trail.setAttribute('fill', 'none');
//       trail.setAttribute('stroke', 'var(--muted)'); trail.setAttribute('stroke-width', '2');
//       trail.setAttribute('stroke-dasharray', '6 5'); trail.setAttribute('stroke-linecap', 'round');
//       pathSvg.appendChild(trail);

//       const progress = document.createElementNS(NS, 'path');
//       progress.setAttribute('d', d); progress.setAttribute('fill', 'none');
//       progress.setAttribute('stroke', 'var(--acid)'); progress.setAttribute('stroke-width', '2.5');
//       progress.setAttribute('stroke-linecap', 'round');
//       const pathLen = trail.getTotalLength();
//       progress.style.strokeDasharray  = pathLen;
//       progress.style.strokeDashoffset = pathLen;
//       progress.style.opacity          = '0.7';
//       pathSvg.appendChild(progress);

//       dots.forEach(({ x, y, color }, i) => {
//         const outer = document.createElementNS(NS, 'circle');
//         outer.setAttribute('cx', x); outer.setAttribute('cy', y); outer.setAttribute('r', 12);
//         outer.setAttribute('fill', color); outer.style.opacity = '0';
//         outer.id = `exp-dot-outer-${i}`; pathSvg.appendChild(outer);

//         const inner = document.createElementNS(NS, 'circle');
//         inner.setAttribute('cx', x); inner.setAttribute('cy', y); inner.setAttribute('r', 5);
//         inner.setAttribute('fill', color); inner.style.opacity = '0';
//         inner.id = `exp-dot-inner-${i}`; pathSvg.appendChild(inner);
//       });

//       const addTerminal = (x, y, color, id) => {
//         const ring = document.createElementNS(NS, 'circle');
//         ring.setAttribute('cx', x); ring.setAttribute('cy', y); ring.setAttribute('r', 9);
//         ring.setAttribute('fill', 'none'); ring.setAttribute('stroke', color);
//         ring.setAttribute('stroke-width', '1.5'); ring.style.opacity = '0.5';
//         ring.id = `${id}-ring`; pathSvg.appendChild(ring);
//         const dot = document.createElementNS(NS, 'circle');
//         dot.setAttribute('cx', x); dot.setAttribute('cy', y); dot.setAttribute('r', 4);
//         dot.setAttribute('fill', color); dot.style.opacity = '0.9';
//         dot.id = `${id}-dot`; pathSvg.appendChild(dot);
//       };

//       const ptStart = trail.getPointAtLength(0);
//       const ptEnd   = trail.getPointAtLength(pathLen);
//       addTerminal(ptStart.x, ptStart.y, 'var(--acid)', 'exp-terminal-start');
//       addTerminal(ptEnd.x,   ptEnd.y,   'var(--acid)', 'exp-terminal-end');

//       // ── Image SVG (replaces rocket) ───────────────────────
//       sizeSvg(rocketSvg);
//       rocketSvg.innerHTML = '';

//       const imgEl = document.createElementNS(NS, 'image');
//       imgEl.setAttribute('href',   CUSTOM_IMAGE_URL);
//       imgEl.setAttribute('x',      String(-IMG_SIZE / 2));
//       imgEl.setAttribute('y',      String(-IMG_SIZE / 2));
//       imgEl.setAttribute('width',  String(IMG_SIZE));
//       imgEl.setAttribute('height', String(IMG_SIZE));
//       imgEl.setAttribute('preserveAspectRatio', 'xMidYMid meet');

//       // Group that GSAP will move + rotate
//       const imgG = document.createElementNS(NS, 'g');
//       imgG.id = 'exp-rocket-g';
//       imgG.appendChild(imgEl);
//       rocketSvg.appendChild(imgG);

//       // Position image at path start
//       const p0    = trail.getPointAtLength(0);
//       const p0fwd = trail.getPointAtLength(5);
//       const angle0 = Math.atan2(p0fwd.y - p0.y, p0fwd.x - p0.x) * (180 / Math.PI) - 90;
//       imgG.setAttribute('transform', `translate(${p0.x}, ${p0.y}) rotate(${angle0})`);

//       // ── Scroll animation ──────────────────────────────────
//       const allCards = root.querySelectorAll('[id^="exp-card-"]');
//       gsap.set(allCards, { opacity: 0, y: 36 });

//       const triggers = [];

//       // FIX 1: Use "bottom bottom" so the image travels the full path
//       // by the time the section's bottom reaches the viewport's bottom.
//       const tMain = gsap.to({ t: 0 }, {
//         t: 1, ease: 'none',
//         scrollTrigger: {
//           trigger: root,
//           start: 'top top',
//           end: 'bottom bottom',
//           scrub: 0.8,           // was 1.2 — snappier tracking
//           onUpdate(self) {
//             const prog  = self.progress;
//             progress.style.strokeDashoffset = pathLen * (1 - prog);
//             const dist  = prog * pathLen;
//             const pt    = trail.getPointAtLength(dist);
//             const ptFwd = trail.getPointAtLength(Math.min(dist + 5, pathLen));
//             const angle = Math.atan2(ptFwd.y - pt.y, ptFwd.x - pt.x) * (180 / Math.PI) - 90;
//             imgG.setAttribute('transform', `translate(${pt.x}, ${pt.y}) rotate(${angle})`);
//           },
//         },
//       });
//       triggers.push(tMain.scrollTrigger);

//       // FIX 2: Card triggers now derived from totalH only (no inflated offset),
//       // so they stay in sync with the image position.
//       dots.forEach(({ y }, i) => {
//         const card     = root.querySelector(`#exp-card-${i}`);
//         const dotOuter = pathSvg.querySelector(`#exp-dot-outer-${i}`);
//         const dotInner = pathSvg.querySelector(`#exp-dot-inner-${i}`);
//         if (!card) return;

//         const t = ScrollTrigger.create({
//           trigger: root,
//           start: () => {
//             const cardFraction = dots[i].y / totalH;
//             const triggerPx    = cardFraction * totalH - window.innerHeight * 0.4;
//             return `top+=${Math.max(0, triggerPx)} top`;
//           },
//           onEnter: () => {
//             gsap.to(card, { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out', overwrite: 'auto' });
//             if (dotOuter) gsap.to(dotOuter, { opacity: 0.18, duration: 0.35 });
//             if (dotInner) gsap.to(dotInner, { opacity: 1,    duration: 0.35 });
//           },
//           onLeaveBack: () => {
//             gsap.to(card, { opacity: 0, y: 36, duration: 0.3, overwrite: 'auto' });
//             if (dotOuter) gsap.to(dotOuter, { opacity: 0, duration: 0.2 });
//             if (dotInner) gsap.to(dotInner, { opacity: 0, duration: 0.2 });
//           },
//         });
//         triggers.push(t);
//       });

//       root._rocketTriggers = triggers;
//       ScrollTrigger.refresh();
//     };

//     let firstObservation = true;
//     const ro = new ResizeObserver(() => {
//       if (firstObservation) {
//         firstObservation = false;
//         requestAnimationFrame(() => requestAnimationFrame(build));
//       } else {
//         clearTimeout(ro._debounce);
//         ro._debounce = setTimeout(build, 150);
//       }
//     });
//     ro.observe(wrap);

//     cleanup = () => {
//       ro.disconnect();
//       clearTimeout(ro._debounce);
//       if (root._rocketTriggers) {
//         root._rocketTriggers.forEach(t => { try { t?.kill?.(); } catch (_) {} });
//         delete root._rocketTriggers;
//       }
//       ScrollTrigger.refresh();
//     };

//     return () => { cleanup?.(); };
//   }, [loaded, isMobile, experiences]);

//   // ── Heading animation ─────────────────────────────────────
//   useEffect(() => {
//     if (!loaded || experiences.length === 0) return;
//     const timer = setTimeout(() => {
//       const root = expRef.current;
//       if (!root) return;

//       const headClip = root.querySelector('.exp-head-clip');
//       const triggers = [];

//       if (headClip) gsap.set(headClip, { clipPath: 'inset(0 100% 0 0)' });
//       ScrollTrigger.refresh();

//       if (headClip) {
//         triggers.push(ScrollTrigger.create({
//           trigger: headClip, start: 'top 90%',
//           onEnter:     () => gsap.to(headClip, { clipPath: 'inset(0 0% 0 0)',   duration: 1.3, ease: 'power4.inOut', overwrite: 'auto' }),
//           onLeaveBack: () => gsap.to(headClip, { clipPath: 'inset(0 100% 0 0)', duration: 0.5, overwrite: 'auto' }),
//           onEnterBack: () => gsap.to(headClip, { clipPath: 'inset(0 0% 0 0)',   duration: 1.3, ease: 'power4.inOut', overwrite: 'auto' }),
//         }));
//       }

//       root._statsTriggers = triggers;
//     }, 150);

//     return () => {
//       clearTimeout(timer);
//       const root = expRef.current;
//       if (root?._statsTriggers) {
//         root._statsTriggers.forEach(t => { try { t?.kill?.(); } catch (_) {} });
//         delete root._statsTriggers;
//       }
//     };
//   }, [loaded, isMobile, experiences]);

//   return (
//     <section id="experience" ref={expRef} style={{ background: 'var(--black)', padding: isMobile ? '5rem 5vw' : '8rem 5vw', position: 'relative', overflow: 'clip' }}>

//       <div style={{  margin: '0 auto', position: 'relative', zIndex: 1 }}>

//         <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.2rem' }}>
//           <Label n="04" text="Experience" />
//         </div>
//         <div style={{ overflow: 'hidden', marginBottom: isMobile ? '3rem' : '5rem' }}>
//           <h2 className="" style={{ fontFamily: 'Syne, sans-serif', fontSize: isMobile ? 'clamp(1.4rem, 5vw, 2rem)' : 'clamp(1.6rem, 3vw, 3rem)', fontWeight: 800, letterSpacing: '-0.04em', lineHeight: 0.9, margin: 0 }}>
//             Career <span style={{ color: 'var(--acid)' }}>Journey</span>
//           </h2>
//         </div>

//         <div ref={wrapRef} className="exp-path-wrap" style={{ position: 'relative' }}>
//           <svg ref={pathSvgRef} style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', zIndex: 1, display: 'block', overflow: 'visible' }} />

//           <div className="exp-cards-col" style={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', paddingBottom: 80 }}>
//             <div style={{ height: 60 }} />
//             {experiences.map((exp, i) => {
//               const isLeft = i % 2 === 0;
//               return (
//                 <div key={i} className="exp-stop" style={{ display: 'flex', alignItems: 'center', minHeight: isMobile ? 160 : 180, paddingTop: 20, paddingBottom: 20, ...(isLeft ? { justifyContent: 'flex-start', paddingRight: isMobile ? '48%' : '52%' } : { justifyContent: 'flex-end', paddingLeft: isMobile ? '48%' : '52%' }) }}>
//                   <div
//                     id={`exp-card-${i}`}
//                     data-cursor-img={IMG?.exp}
//                     style={{ background: 'var(--black)', border: `1px solid ${exp.color}22`, borderLeft: `2px solid ${exp.color}`, borderRadius: 4, padding: isMobile ? '1.4rem' : '1.8rem 2rem', maxWidth: isMobile ? 220 : 300, width: '100%', position: 'relative', overflow: 'hidden', opacity: 0, transition: 'border-color 0.3s, background 0.3s' }}
//                     onMouseEnter={e => { e.currentTarget.style.background = 'var(--black)'; e.currentTarget.style.borderColor = exp.color; }}
//                     onMouseLeave={e => { e.currentTarget.style.background = 'var(--black)'; e.currentTarget.style.borderLeftColor = exp.color; e.currentTarget.style.borderTopColor = `${exp.color}22`; e.currentTarget.style.borderRightColor = `${exp.color}22`; e.currentTarget.style.borderBottomColor = `${exp.color}22`; }}
//                   >
//                     <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: exp.color, opacity: 0.5 }} />
//                     <div style={{ display: 'inline-block', fontFamily: 'Space Mono', fontSize: '0.58rem', color: exp.color, padding: '0.25rem 0.6rem', border: `1px solid ${exp.color}44`, letterSpacing: '0.1em', marginBottom: '0.75rem' }}>{exp.year}</div>
//                     <h3 style={{ fontFamily: 'Syne', fontSize: isMobile ? '1rem' : '1.2rem', fontWeight: 800, letterSpacing: '-0.02em', marginBottom: '0.25rem', color: 'var(--white)' }}>{exp.role}</h3>
//                     <div style={{ fontFamily: 'Space Mono', fontSize: '0.65rem', color: exp.color, marginBottom: '0.65rem', letterSpacing: '0.08em' }}>{exp.co}</div>
//                     <p style={{ fontFamily: 'Syne', fontSize: isMobile ? '0.82rem' : '0.88rem', color: 'var(--muted)', lineHeight: 1.7, margin: 0 }}>{exp.desc}</p>
//                     <div style={{ marginTop: '1.2rem', height: 1, background: exp.color, opacity: 0.15 }} />
//                   </div>
//                 </div>
//               );
//             })}
//             <div style={{ height: 40 }} />
//           </div>

//           {/* Image SVG — replaces the rocket SVG */}
//           <svg ref={rocketSvgRef} style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', zIndex: 1, display: 'block', overflow: 'visible' }} />
//         </div>
//       </div>
//     </section>
//   );
// }

import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { fetchExperiences, IMG } from './data';
import { Label } from './utils';

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

// ── Swap this URL with your own image ──────────────────────
const CUSTOM_IMAGE_URL = './bg_rc.png';
// Image display size (in SVG units / px)
const IMG_SIZE = 48;
// Turn the image to face the direction of travel (set false for a non-directional image)
const ROTATE_WITH_PATH = true;
// Change this number to get a different (but stable) route layout
const ROUTE_SEED = 7;

// ═══════════════════════════════════════════════════════════
//  Radian-style route: straight segments, sharp + softly rounded corners
// ═══════════════════════════════════════════════════════════

// Seeded PRNG → identical route on every rebuild / resize
const mulberry32 = (seed) => () => {
  seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
  let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

// Turning points as [x-fraction, y-fraction] along each card → card leg.
// Mixes shallow runs, steep drops, vertical drops and a few back-tracks.
// Equal x-fractions = vertical drop. A falling x-fraction = back-track.
const LEGS = [
  [[0.28, 0.10], [0.46, 0.58], [0.74, 0.76]],
  [[0.40, 0.28], [0.40, 0.64], [0.72, 0.80]],
  [[0.20, 0.18], [0.55, 0.36], [0.62, 0.82]],
  [[0.35, 0.12], [0.58, 0.32], [0.58, 0.70], [0.82, 0.86]],
  [[0.58, 0.20], [0.32, 0.50], [0.70, 0.72]],
  [[0.15, 0.30], [0.15, 0.55], [0.50, 0.66], [0.84, 0.84]],
];

function buildRoutePath({ W, startY, endY, anchors, isMobile, seed = ROUTE_SEED }) {
  const rand   = mulberry32(seed);
  const pad    = isMobile ? 16 : 48;
  const clampX = (x) => Math.max(pad, Math.min(W - pad, x));
  const cx     = W / 2;

  const pts     = [{ x: cx, y: startY, r: 0 }];
  const targets = [...anchors, { x: cx, y: endY }];

  targets.forEach((target) => {
    const A  = pts[pts.length - 1];
    const dx = target.x - A.x;
    const dy = target.y - A.y;
    const leg = LEGS[Math.floor(rand() * LEGS.length)];

    leg.forEach(([fx, fy]) => {
      const x = clampX(A.x + dx * (fx + (rand() - 0.5) * 0.10));
      const y = A.y + dy * Math.min(0.92, Math.max(0.05, fy + (rand() - 0.5) * 0.08));
      // some corners razor-sharp, some softly rounded
      pts.push({ x, y, r: rand() < 0.45 ? 0 : 8 + rand() * 22 });
    });
    pts.push({ x: target.x, y: target.y, r: 0 }); // card dot – always sharp
  });

  // drop near-duplicate points so we never divide by a 0-length segment
  const clean = pts.filter((p, i) => i === 0 || Math.hypot(p.x - pts[i - 1].x, p.y - pts[i - 1].y) > 2);

  let d = `M ${clean[0].x} ${clean[0].y}`;
  for (let i = 1; i < clean.length - 1; i++) {
    const a = clean[i - 1], p = clean[i], b = clean[i + 1];
    if (!p.r) { d += ` L ${p.x} ${p.y}`; continue; }
    const l1 = Math.hypot(a.x - p.x, a.y - p.y);
    const l2 = Math.hypot(b.x - p.x, b.y - p.y);
    const r  = Math.min(p.r, l1 / 2, l2 / 2);
    d += ` L ${p.x + (a.x - p.x) / l1 * r} ${p.y + (a.y - p.y) / l1 * r}`;
    d += ` Q ${p.x} ${p.y} ${p.x + (b.x - p.x) / l2 * r} ${p.y + (b.y - p.y) / l2 * r}`;
  }
  const end = clean[clean.length - 1];
  return d + ` L ${end.x} ${end.y}`;
}

export default function Experience({ loaded, isMobile }) {
  const [experiences, setExperiences] = useState([]);
  const expRef       = useRef(null);
  const pathSvgRef   = useRef(null);
  const rocketSvgRef = useRef(null);
  const wrapRef      = useRef(null);

  // ── Fetch from Firestore ──────────────────────────────────
  useEffect(() => {
    fetchExperiences().then(setExperiences).catch(console.error);
  }, []);

  // ── Custom-image path animation ───────────────────────────
  useEffect(() => {
    if (!loaded || experiences.length === 0) return;

    const root      = expRef.current;
    const pathSvg   = pathSvgRef.current;
    const rocketSvg = rocketSvgRef.current;
    const wrap      = wrapRef.current;
    if (!root || !pathSvg || !rocketSvg || !wrap) return;

    let cleanup = null;

    const build = () => {
      if (root._rocketTriggers) {
        root._rocketTriggers.forEach(t => { try { t?.kill?.(); } catch (_) {} });
        delete root._rocketTriggers;
      }

      const stops = root.querySelectorAll('.exp-stop');
      if (!stops.length) return;

      gsap.set(stops, { clearProps: 'transform,opacity' });
      void wrap.getBoundingClientRect();

      const W      = wrap.offsetWidth;
      const totalH = wrap.offsetHeight;

      const wrapRect = wrap.getBoundingClientRect();
      const dots = [];
      let runY = 60;

      stops.forEach((s, i) => {
        const card = s.querySelector(`#exp-card-${i}`) || s.firstElementChild;
        let cardX;
        if (card) {
          const cr = card.getBoundingClientRect();
          cardX = (cr.left + cr.width / 2) - wrapRect.left;
        } else {
          cardX = i % 2 === 0 ? W * 0.25 : W * 0.75;
        }
        dots.push({ x: cardX, y: runY + s.offsetHeight / 2, color: experiences[i]?.color || 'var(--acid)' });
        runY += s.offsetHeight;
      });

      // ── Radian-style angular route through every card dot ──
      const startY = 10;
      const endY   = totalH - 10;
      const d = buildRoutePath({ W, startY, endY, anchors: dots, isMobile });

      const sizeSvg = (svg) => {
        svg.setAttribute('viewBox', `0 0 ${W} ${totalH}`);
        svg.setAttribute('width',   W);
        svg.setAttribute('height',  totalH);
        svg.style.width  = `${W}px`;
        svg.style.height = `${totalH}px`;
      };

      const NS = 'http://www.w3.org/2000/svg';

      // ── Path SVG (trail + dots) ───────────────────────────
      sizeSvg(pathSvg);
      pathSvg.innerHTML = '';

      // Thin solid trail (like the Radian line)
      const trail = document.createElementNS(NS, 'path');
      trail.setAttribute('d', d); trail.setAttribute('fill', 'none');
      trail.setAttribute('stroke', 'var(--muted)'); trail.setAttribute('stroke-width', '1.5');
      trail.setAttribute('stroke-linecap', 'round'); trail.setAttribute('stroke-linejoin', 'round');
      pathSvg.appendChild(trail);

      const progress = document.createElementNS(NS, 'path');
      progress.setAttribute('d', d); progress.setAttribute('fill', 'none');
      progress.setAttribute('stroke', 'var(--acid)'); progress.setAttribute('stroke-width', '2.5');
      progress.setAttribute('stroke-linecap', 'round'); progress.setAttribute('stroke-linejoin', 'round');
      const pathLen = trail.getTotalLength();
      progress.style.strokeDasharray  = pathLen;
      progress.style.strokeDashoffset = pathLen;
      progress.style.opacity          = '0.7';
      pathSvg.appendChild(progress);

      dots.forEach(({ x, y, color }, i) => {
        const outer = document.createElementNS(NS, 'circle');
        outer.setAttribute('cx', x); outer.setAttribute('cy', y); outer.setAttribute('r', 12);
        outer.setAttribute('fill', color); outer.style.opacity = '0';
        outer.id = `exp-dot-outer-${i}`; pathSvg.appendChild(outer);

        const inner = document.createElementNS(NS, 'circle');
        inner.setAttribute('cx', x); inner.setAttribute('cy', y); inner.setAttribute('r', 5);
        inner.setAttribute('fill', color); inner.style.opacity = '0';
        inner.id = `exp-dot-inner-${i}`; pathSvg.appendChild(inner);
      });

      const addTerminal = (x, y, color, id) => {
        const ring = document.createElementNS(NS, 'circle');
        ring.setAttribute('cx', x); ring.setAttribute('cy', y); ring.setAttribute('r', 9);
        ring.setAttribute('fill', 'none'); ring.setAttribute('stroke', color);
        ring.setAttribute('stroke-width', '1.5'); ring.style.opacity = '0.5';
        ring.id = `${id}-ring`; pathSvg.appendChild(ring);
        const dot = document.createElementNS(NS, 'circle');
        dot.setAttribute('cx', x); dot.setAttribute('cy', y); dot.setAttribute('r', 4);
        dot.setAttribute('fill', color); dot.style.opacity = '0.9';
        dot.id = `${id}-dot`; pathSvg.appendChild(dot);
      };

      const ptStart = trail.getPointAtLength(0);
      const ptEnd   = trail.getPointAtLength(pathLen);
      addTerminal(ptStart.x, ptStart.y, 'var(--acid)', 'exp-terminal-start');
      addTerminal(ptEnd.x,   ptEnd.y,   'var(--acid)', 'exp-terminal-end');

      // Heading at a given distance along the route. Uses a wide look-around
      // window so the image eases through sharp corners instead of snapping.
      const LOOK = 28;
      const angleAt = (dist) => {
        if (!ROTATE_WITH_PATH) return 0;
        const a = trail.getPointAtLength(Math.max(0, dist - LOOK));
        const b = trail.getPointAtLength(Math.min(pathLen, dist + LOOK));
        return Math.atan2(b.y - a.y, b.x - a.x) * (180 / Math.PI) - 90;
      };

      // ── Image SVG (replaces rocket) ───────────────────────
      sizeSvg(rocketSvg);
      rocketSvg.innerHTML = '';

      const imgEl = document.createElementNS(NS, 'image');
      imgEl.setAttribute('href',   CUSTOM_IMAGE_URL);
      imgEl.setAttribute('x',      String(-IMG_SIZE / 2));
      imgEl.setAttribute('y',      String(-IMG_SIZE / 2));
      imgEl.setAttribute('width',  String(IMG_SIZE));
      imgEl.setAttribute('height', String(IMG_SIZE));
      imgEl.setAttribute('preserveAspectRatio', 'xMidYMid meet');

      // Group that GSAP will move + rotate
      const imgG = document.createElementNS(NS, 'g');
      imgG.id = 'exp-rocket-g';
      imgG.appendChild(imgEl);
      rocketSvg.appendChild(imgG);

      // Position image at path start
      const p0 = trail.getPointAtLength(0);
      imgG.setAttribute('transform', `translate(${p0.x}, ${p0.y}) rotate(${angleAt(0)})`);

      // ── Scroll animation ──────────────────────────────────
      const allCards = root.querySelectorAll('[id^="exp-card-"]');
      gsap.set(allCards, { opacity: 0, y: 36 });

      const triggers = [];

      // Image travels the full route by the time the section's bottom
      // reaches the viewport's bottom.
      const tMain = gsap.to({ t: 0 }, {
        t: 1, ease: 'none',
        scrollTrigger: {
          trigger: root,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 0.8,
          onUpdate(self) {
            const prog = self.progress;
            progress.style.strokeDashoffset = pathLen * (1 - prog);
            const dist = prog * pathLen;
            const pt   = trail.getPointAtLength(dist);
            imgG.setAttribute('transform', `translate(${pt.x}, ${pt.y}) rotate(${angleAt(dist)})`);
          },
        },
      });
      triggers.push(tMain.scrollTrigger);

      // Card triggers derived from totalH only, so they stay in sync with the image.
      dots.forEach(({ y }, i) => {
        const card     = root.querySelector(`#exp-card-${i}`);
        const dotOuter = pathSvg.querySelector(`#exp-dot-outer-${i}`);
        const dotInner = pathSvg.querySelector(`#exp-dot-inner-${i}`);
        if (!card) return;

        const t = ScrollTrigger.create({
          trigger: root,
          start: () => {
            const cardFraction = dots[i].y / totalH;
            const triggerPx    = cardFraction * totalH - window.innerHeight * 0.4;
            return `top+=${Math.max(0, triggerPx)} top`;
          },
          onEnter: () => {
            gsap.to(card, { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out', overwrite: 'auto' });
            if (dotOuter) gsap.to(dotOuter, { opacity: 0.18, duration: 0.35 });
            if (dotInner) gsap.to(dotInner, { opacity: 1,    duration: 0.35 });
          },
          onLeaveBack: () => {
            gsap.to(card, { opacity: 0, y: 36, duration: 0.3, overwrite: 'auto' });
            if (dotOuter) gsap.to(dotOuter, { opacity: 0, duration: 0.2 });
            if (dotInner) gsap.to(dotInner, { opacity: 0, duration: 0.2 });
          },
        });
        triggers.push(t);
      });

      root._rocketTriggers = triggers;
      ScrollTrigger.refresh();
    };

    let firstObservation = true;
    const ro = new ResizeObserver(() => {
      if (firstObservation) {
        firstObservation = false;
        requestAnimationFrame(() => requestAnimationFrame(build));
      } else {
        clearTimeout(ro._debounce);
        ro._debounce = setTimeout(build, 150);
      }
    });
    ro.observe(wrap);

    cleanup = () => {
      ro.disconnect();
      clearTimeout(ro._debounce);
      if (root._rocketTriggers) {
        root._rocketTriggers.forEach(t => { try { t?.kill?.(); } catch (_) {} });
        delete root._rocketTriggers;
      }
      ScrollTrigger.refresh();
    };

    return () => { cleanup?.(); };
  }, [loaded, isMobile, experiences]);

  // ── Heading animation ─────────────────────────────────────
  useEffect(() => {
    if (!loaded || experiences.length === 0) return;
    const timer = setTimeout(() => {
      const root = expRef.current;
      if (!root) return;

      const headClip = root.querySelector('.exp-head-clip');
      const triggers = [];

      if (headClip) gsap.set(headClip, { clipPath: 'inset(0 100% 0 0)' });
      ScrollTrigger.refresh();

      if (headClip) {
        triggers.push(ScrollTrigger.create({
          trigger: headClip, start: 'top 90%',
          onEnter:     () => gsap.to(headClip, { clipPath: 'inset(0 0% 0 0)',   duration: 1.3, ease: 'power4.inOut', overwrite: 'auto' }),
          onLeaveBack: () => gsap.to(headClip, { clipPath: 'inset(0 100% 0 0)', duration: 0.5, overwrite: 'auto' }),
          onEnterBack: () => gsap.to(headClip, { clipPath: 'inset(0 0% 0 0)',   duration: 1.3, ease: 'power4.inOut', overwrite: 'auto' }),
        }));
      }

      root._statsTriggers = triggers;
    }, 150);

    return () => {
      clearTimeout(timer);
      const root = expRef.current;
      if (root?._statsTriggers) {
        root._statsTriggers.forEach(t => { try { t?.kill?.(); } catch (_) {} });
        delete root._statsTriggers;
      }
    };
  }, [loaded, isMobile, experiences]);

  return (
    <section id="experience" ref={expRef} style={{ background: 'var(--black)', padding: isMobile ? '5rem 5vw' : '8rem 5vw', position: 'relative', overflow: 'clip' }}>

      <div style={{  margin: '0 auto', position: 'relative', zIndex: 1 }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.2rem' }}>
          <Label n="04" text="Experience" />
        </div>
        <div style={{ overflow: 'hidden', marginBottom: isMobile ? '3rem' : '5rem' }}>
          <h2 className="" style={{ fontFamily: 'Syne, sans-serif', fontSize: isMobile ? 'clamp(1.4rem, 5vw, 2rem)' : 'clamp(1.6rem, 3vw, 3rem)', fontWeight: 800, letterSpacing: '-0.04em', lineHeight: 0.9, margin: 0 }}>
            Career <span style={{ color: 'var(--acid)' }}>Journey</span>
          </h2>
        </div>

        <div ref={wrapRef} className="exp-path-wrap" style={{ position: 'relative' }}>
          <svg ref={pathSvgRef} style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', zIndex: 1, display: 'block', overflow: 'visible' }} />

          <div className="exp-cards-col" style={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', paddingBottom: 80 }}>
            <div style={{ height: 60 }} />
            {experiences.map((exp, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div key={i} className="exp-stop" style={{ display: 'flex', alignItems: 'center', minHeight: isMobile ? 160 : 180, paddingTop: 20, paddingBottom: 20, ...(isLeft ? { justifyContent: 'flex-start', paddingRight: isMobile ? '48%' : '52%' } : { justifyContent: 'flex-end', paddingLeft: isMobile ? '48%' : '52%' }) }}>
                  <div
                    id={`exp-card-${i}`}
                    data-cursor-img={IMG?.exp}
                    style={{ background: 'var(--black)', border: `1px solid ${exp.color}22`, borderLeft: `2px solid ${exp.color}`, borderRadius: 4, padding: isMobile ? '1.4rem' : '1.8rem 2rem', maxWidth: isMobile ? 220 : 300, width: '100%', position: 'relative', overflow: 'hidden', opacity: 0, transition: 'border-color 0.3s, background 0.3s' }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'var(--black)'; e.currentTarget.style.borderColor = exp.color; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'var(--black)'; e.currentTarget.style.borderLeftColor = exp.color; e.currentTarget.style.borderTopColor = `${exp.color}22`; e.currentTarget.style.borderRightColor = `${exp.color}22`; e.currentTarget.style.borderBottomColor = `${exp.color}22`; }}
                  >
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: exp.color, opacity: 0.5 }} />
                    <div style={{ display: 'inline-block', fontFamily: 'Space Mono', fontSize: '0.58rem', color: exp.color, padding: '0.25rem 0.6rem', border: `1px solid ${exp.color}44`, letterSpacing: '0.1em', marginBottom: '0.75rem' }}>{exp.year}</div>
                    <h3 style={{ fontFamily: 'Syne', fontSize: isMobile ? '1rem' : '1.2rem', fontWeight: 800, letterSpacing: '-0.02em', marginBottom: '0.25rem', color: 'var(--white)' }}>{exp.role}</h3>
                    <div style={{ fontFamily: 'Space Mono', fontSize: '0.65rem', color: exp.color, marginBottom: '0.65rem', letterSpacing: '0.08em' }}>{exp.co}</div>
                    <p style={{ fontFamily: 'Syne', fontSize: isMobile ? '0.82rem' : '0.88rem', color: 'var(--muted)', lineHeight: 1.7, margin: 0 }}>{exp.desc}</p>
                    <div style={{ marginTop: '1.2rem', height: 1, background: exp.color, opacity: 0.15 }} />
                  </div>
                </div>
              );
            })}
            <div style={{ height: 40 }} />
          </div>

          {/* Image SVG — replaces the rocket SVG */}
          <svg ref={rocketSvgRef} style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', zIndex: 1, display: 'block', overflow: 'visible' }} />
        </div>
      </div>
    </section>
  );
}